import { ScopesListApiResponse } from '../dtos/responses/scopes-list-response';
import { ICreateScopeResponse } from '../dtos/responses/create-scope-response';
import { IUpdateScopeResponse } from '../dtos/responses/update-scope-response';
import { ICreateScopeRequest } from '../dtos/requests/create-scope.request';
import { IUpdateScopeRequest } from '../dtos/requests/update-scope.request';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Scopes, userManagementUrl } from '../../../../../constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DeprecatedPaginationParameters } from '../../../../../trash/shared/interfaces/shared-interfaces';

@Injectable({
    providedIn: 'root'
})
export class ScopesService {
    collectionUrl: string = `${userManagementUrl}/${Scopes}`;

    constructor(private http: HttpClient) {}

    getAll(params?: DeprecatedPaginationParameters): Observable<ScopesListApiResponse> {
        let paramsItem = new HttpParams();

        // Loop through the parameters and append them if defined
        if (params) {
            Object.keys(params).forEach(key => {
                const value = (params as any)[key];
                if (value !== undefined && value !== null && value !== '') {
                    paramsItem = paramsItem.append(this.mapParamKey(key), value);
                }
            });
        }

        // Return the HTTP GET call with the expected response type
        return this.http.get<ScopesListApiResponse>(`${this.collectionUrl}`, { params: paramsItem });
    }
    // Helper method to map parameter keys if needed (optional)
    private mapParamKey(key: string): string {
        const map: { [key: string]: string } = {
            sortColumn: 'SortColumn',
            sortOrder: 'SortOrder',
            searchField: 'SearchField',
            SearchKeyword: 'SearchKeyword',
            page: 'Page',
            pageSize: 'PageSize',
            order: 'Order',
            orderBy: 'OrderBy'
        };
        return map[key] || key;
    }

    // Create a new resource (POST)
    async create(request: ICreateScopeRequest): Promise<Observable<ICreateScopeResponse>> {
        return await this.http.post<ICreateScopeResponse>(`${this.collectionUrl}`, request);
    }

    // Update a resource (PUT)
    async update(request: IUpdateScopeRequest, id: number | string): Promise<Observable<IUpdateScopeResponse>> {
        return await this.http.patch<IUpdateScopeResponse>(`${this.collectionUrl}/${id}`, request);
    }

    // Get a single resource by ID (GET)
    // getById(id: string): Observable<TResponse> {
    //   return this.http.get<TResponse>(`${this.baseUrl}/${this.collectionName}/${id}`);
    // }

    // Delete a single resource by ID (DELETE)
    // delete(id: string): Observable<void> {
    //   return this.http.delete<void>(`${this.baseUrl}/${this.collectionName}/${id}`);
    // }
}
